import type React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

type DashboardCardProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  to?: string;
  className?: string;
  contentClassName?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  children: React.ReactNode;
};

const baseClassName =
  "block min-w-0 overflow-hidden rounded-xl border border-myteengig-border bg-white p-3 shadow-sm transition-colors hover:bg-myteengig-background sm:p-5";

const DashboardCard = ({ title, subtitle, to, className, contentClassName, onClick, children }: DashboardCardProps) => {
  const content = (
    <>
      <header className={clsx("mb-4", contentClassName)}>
        <h3 className="text-lg font-semibold text-myteengig-text-primary">{title}</h3>
        {subtitle ? <p className="mt-1 text-sm text-myteengig-text-muted">{subtitle}</p> : null}
      </header>
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={clsx(baseClassName, className)}>
        {content}
      </Link>
    );
  }

  return <section className={clsx(baseClassName, className)} onClick={onClick}>{content}</section>;
};

export default DashboardCard;
